import { useEffect, useState } from 'react';
import { fetchKioskInfo } from '@/services/kioskInfoCache';

export type DomainType = 'kiosk' | 'mobile' | null;

/**
 * Resolves domain type from GET /api/kiosk/info (cached in localStorage when offline).
 * - kiosk: client kiosk (e.g. client.kioskservice.club) — no Play link
 * - mobile: mobile client (e.g. m.kioskservice.club) — show Play link when gameUrl exists
 */
export function useDomainType(): DomainType | 'loading' {
  const [domainType, setDomainType] = useState<DomainType | 'loading'>('loading');

  useEffect(() => {
    const host = globalThis.location?.hostname;
    if (!host) {
      setDomainType(null);
      return;
    }
    void fetchKioskInfo().then((payload) => {
      const type = payload?.type ?? '';
      if (type === 'kiosk' || type === 'mobile') {
        setDomainType(type);
        return;
      }
      // Dev only: when /api/kiosk/info has no row or returns empty (e.g. first load), optional override
      const override = import.meta.env.VITE_DEV_DOMAIN_TYPE?.trim().toLowerCase();
      if (import.meta.env.DEV && (override === 'kiosk' || override === 'mobile')) {
        setDomainType(override);
        return;
      }
      setDomainType(null);
    });
  }, []);

  return domainType;
}
